export default {
  problem_list: {},
  cause_list: {},
  change_list: {},
  skill_list: {},
  skill_description: {},
  config_list: {},
  config_list_skills: {},
  tips_list: {},
  skill_tips_list: {},
  popup: {
    problem: {},
  },
  changesByCategory: {},
};
